'use strict';

import isRenewAllowedByPeriod from './isRenewAllowedByPeriod';

/**
 * Decoupled into separate function condition which identifies either product's renewal is allowed
 * or not based on the provided information.
 *
 * For DB API and doBoard - renew is possible for any period.
 * For SSL - renew is not allowed.
 * For all other products - renew is available only for 1 Year / 1 Month period.
 *
 * @returns {boolean}
 */
export default (period, productId) => productId === 2 || productId === 7
    || (isRenewAllowedByPeriod(period) && productId !== 5);
